import { InputText } from "primereact/inputtext";

import { Checkbox, Dialog, DialogFooter, FormField } from "@/ds";
import {
  NAME_LABEL,
  NAME_MAX_LENGTH,
  NAME_PLACEHOLDER,
  PERMISSIONS_EMPTY_MESSAGE,
  PERMISSIONS_ERROR_MESSAGE,
  PERMISSIONS_LABEL,
  PERMISSIONS_LOADING_MESSAGE,
} from "./role-form-dialog.constants";
import styles from "./role-form-dialog.module.scss";
import type { PermissoesEstado, RoleFormDialogViewModel } from "./types-role-form-dialog";

const MENSAGENS: Record<Exclude<PermissoesEstado, "lista">, { texto: string; testId: string }> = {
  carregando: { texto: PERMISSIONS_LOADING_MESSAGE, testId: "role-form-permissions-loading" },
  erro: { texto: PERMISSIONS_ERROR_MESSAGE, testId: "role-form-permissions-error" },
  vazio: { texto: PERMISSIONS_EMPTY_MESSAGE, testId: "role-form-permissions-empty" },
};

/** Modal Novo/Editar perfil (Figma 4434:111717 e 4987:43761): Nome e tabela simples Nome/Descrição com checkbox. */
export function RoleFormDialogView({
  formId,
  titulo,
  nome,
  permissoes,
  isSubmitting,
  podeSalvar,
  enviar,
  cancelar,
}: RoleFormDialogViewModel) {
  return (
    <Dialog
      visible
      className={styles.dialog}
      header={titulo}
      onHide={cancelar}
      locked={isSubmitting}
      footer={
        <DialogFooter
          cancelVariant="text"
          cancelTestId="role-form-cancel"
          confirmTestId="role-form-save"
          confirmLabel="Salvar"
          confirmButtonProps={{ disabled: !podeSalvar }}
          formId={formId}
          loading={isSubmitting}
          locked={isSubmitting}
          onCancel={cancelar}
        />
      }
      data-testid="role-form-dialog"
    >
      <form id={formId} className={styles.form} onSubmit={enviar} noValidate>
        <FormField.Root required error={nome.error} disabled={isSubmitting || nome.bloqueado}>
          <FormField.Label>{NAME_LABEL}</FormField.Label>
          <FormField.Control>
            <InputText
              value={nome.value}
              maxLength={NAME_MAX_LENGTH}
              placeholder={NAME_PLACEHOLDER}
              title={nome.dica}
              onChange={(event) => nome.digitar(event.currentTarget.value)}
              data-testid="role-form-name"
            />
          </FormField.Control>
          <FormField.Error data-testid="role-form-name-error" />
        </FormField.Root>

        <fieldset className={styles.permissions}>
          <legend className={styles.legend}>{PERMISSIONS_LABEL}</legend>

          {permissoes.estado === "lista" ? (
            <div className={styles.scroll}>
              <table className={styles.table} data-testid="role-form-permissions">
                <thead>
                  <tr>
                    <th scope="col" className={styles.selectColumn}>
                      <span className={styles.srOnly}>Selecionar</span>
                    </th>
                    <th scope="col">Nome</th>
                    <th scope="col">Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  {permissoes.linhas.map((linha) => (
                    <tr key={linha.id}>
                      <td className={styles.selectColumn}>
                        <Checkbox
                          inputId={linha.testId}
                          checked={linha.marcada}
                          onChange={() => permissoes.alternar(linha.id)}
                          disabled={isSubmitting}
                          aria-label={linha.nome}
                          data-testid={linha.testId}
                        />
                      </td>
                      <td className={styles.name}>{linha.nome}</td>
                      <td className={styles.description}>{linha.descricao}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p
              className={styles.state}
              role="status"
              data-testid={MENSAGENS[permissoes.estado].testId}
            >
              {MENSAGENS[permissoes.estado].texto}
            </p>
          )}
        </fieldset>
      </form>
    </Dialog>
  );
}
